import { label, field } from "../UI/tokens";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import styled from "styled-components";

export const LabelInput = styled(FormLabel)`
${label}
`;

export const DivInput = styled.div`
    border-radius: 0px 0px 5px 0px;
`;

export const FormGroupInput = styled(FormGroup)`
    margin-bottom: 1px;

margin-bottom: 14px; min-width: 0;
`;

export const FormControlInput = styled(FormControl)`
${field}
`;